
<template>
  <div class="download">
    <component :is="$store.state.device"></component>
  </div>
</template>

<script>
import m from './device/m.vue'
import pc from './device/pc.vue'

export default {
  name: 'download',

  components: {
    pc,
    m
  }
}
</script>
